var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartfreeCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.1538,
    cy: 43.1538,
    r: 43.1538,
    fill: "#8AD6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1778_6400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5582 31.1554L55.5879 21.4693V60.2843H67.5929V39.02C67.5929 36.0673 66.5005 33.2366 64.5582 31.1554Z",
    fill: "#FFE8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8687 53.2116L18.0876 34.2384C17.4067 32.3338 18.2874 30.1943 20.0555 29.4605L52.0634 16.1728C53.8307 15.439 55.8159 16.3882 56.4967 18.2937L63.2778 37.2669C63.9586 39.1715 63.078 41.311 61.3098 42.0448L29.3028 55.3325C27.5346 56.0663 25.5504 55.1162 24.8687 53.2116Z",
    fill: "#FF4D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9408 25.1289L20.5625 41.1613L23.1179 48.3107L61.4979 32.2856L58.9408 25.1289Z",
    fill: "#B5374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8574 39.9525V19.6208C17.8574 17.5793 19.3932 15.9241 21.2874 15.9241H55.5875C57.4817 15.9241 59.0175 17.5793 59.0175 19.6208V39.9524C59.0175 41.9939 57.4817 43.6491 55.5875 43.6491H21.2874C19.3932 43.6492 17.8574 41.994 17.8574 39.9525Z",
    fill: "#33B8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5872 15.9241H51.9428L26.2178 43.6492H55.5872C57.4813 43.6492 59.0171 41.994 59.0171 39.9525V19.6208C59.0171 17.5793 57.4813 15.9241 55.5872 15.9241Z",
    fill: "#0097D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7171 30.7108H21.2871V32.5592H24.7171V30.7108Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7171 36.2559H21.2871V38.1042H24.7171V36.2559Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1526 36.2559H36.7227V38.1042H40.1526V36.2559Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8626 30.7108H26.4326V32.5592H29.8626V30.7108Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0071 30.7108H31.5771V32.5592H35.0071V30.7108Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1526 30.7108H36.7227V32.5592H40.1526V30.7108Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7297 19.6208H53.0146V22.3933H54.7297V19.6208Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 19.6208H49.585V22.3933H51.3V19.6208Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8703 19.6208H46.1553V22.3933H47.8703V19.6208Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4396 19.6208H42.7246V22.3933H44.4396V19.6208Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5922 60.2842H52.1572V69.5259H67.5922V60.2842Z",
    fill: "#99C633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6411 32.6193C48.1867 31.0574 45.8329 31.062 44.3837 32.6294C42.9825 34.1451 42.9337 36.5803 44.2731 38.1596L51.3003 46.4217C49.1883 50.4058 49.2784 55.3187 51.5344 59.2094L52.1578 60.2843H63.3054V47.3458L49.6411 32.6193Z",
    fill: "#FFE8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4455 63.0567H54.7305V64.9051H56.4455V63.0567Z",
    fill: "#6B962A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2871 25.5355V21.0995C21.2871 20.2825 21.901 19.6209 22.6591 19.6209H26.7751C27.5332 19.6209 28.1471 20.2825 28.1471 21.0995V25.5355C28.1471 26.3525 27.5332 27.0142 26.7751 27.0142H22.6592C21.9011 27.0142 21.2871 26.3524 21.2871 25.5355Z",
    fill: "#FFB400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8596 22.3933H21.2871V24.2417H23.8596V22.3933Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1477 22.3933H25.5752V24.2417H28.1477V22.3933Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.447 47.3458C62.2198 47.3458 62.0011 47.2488 61.8408 47.0751L58.4108 43.3784C58.0815 43.0115 58.091 42.4265 58.4322 42.0717C58.765 41.7261 59.2915 41.7261 59.6233 42.0717L63.0533 45.7683C63.3877 46.1297 63.3877 46.7146 63.0533 47.0751C62.8921 47.2488 62.6743 47.3458 62.447 47.3458Z",
    fill: "#F2A46F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8751 24.7907V19.6208C59.8725 17.0701 57.9542 15.0027 55.5875 15H21.2875C18.9208 15.0027 17.0025 17.0701 17 19.6208V39.9524C17.0068 42.3128 18.6661 44.2858 20.845 44.5252L24.0683 53.5433C24.9198 55.9249 27.4006 57.1115 29.6103 56.1938L49.7393 47.8375C48.3484 51.7532 48.7437 56.1449 50.8077 59.6992L51.3 60.5485V69.5259C51.3 70.036 51.6841 70.45 52.1574 70.45H67.5924C68.0658 70.45 68.4499 70.036 68.4499 69.5259V39.02C68.4422 35.8242 67.2614 32.7625 65.1648 30.5019L59.8751 24.7907ZM59.8751 30.3171L62.4776 37.5987C62.9878 39.0274 62.3267 40.6317 61.001 41.1816L59.5132 41.8008C59.7508 41.2186 59.8742 40.5893 59.8751 39.9524V30.3171ZM18.715 39.9525V19.6208C18.715 18.0895 19.8667 16.8483 21.2875 16.8483H55.5876C57.0085 16.8483 58.1601 18.0895 58.1601 19.6208V25.4948H58.1524L58.1601 25.5161V39.9525C58.1533 40.1133 58.1344 40.2741 58.1018 40.4313L50.2471 31.965C48.4395 30.0621 45.5437 30.0981 43.7781 32.0463C42.094 33.9038 42.0357 36.8501 43.6444 38.7835L46.9929 42.725H21.2875C19.8666 42.725 18.715 41.4839 18.715 39.9525ZM29.7005 44.5733L23.6028 47.1037L22.7006 44.5733H29.7005ZM28.9939 54.4693C27.6682 55.0201 26.1796 54.3076 25.6685 52.8788L24.2219 48.8244L34.4579 44.5732V44.5678H48.5646L49.6794 45.8774L28.9939 54.4693ZM66.735 68.6017H53.015V61.2084H66.735V68.6017ZM66.735 59.36H52.6334L52.2612 58.7196C50.1707 55.119 50.0875 50.5703 52.0443 46.8837C52.2295 46.5344 52.184 46.0973 51.932 45.8006L44.9047 37.5385C43.8397 36.2817 43.9212 34.3326 45.0873 33.1839C46.2149 32.0739 47.9531 32.1146 49.0344 33.2763L62.6986 47.9992L63.9111 46.6925L60.7384 43.273L61.6182 42.9033C63.8262 41.9856 64.9264 39.3139 64.0766 36.9332L61.174 28.8106L63.9523 31.8105C65.7274 33.7227 66.728 36.3149 66.7349 39.0199L66.735 59.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7751 27.9383C28.0065 27.9383 29.0046 26.8626 29.0046 25.5355V21.0995C29.0046 19.7724 28.0065 18.6967 26.7751 18.6967H22.6592C21.4278 18.6967 20.4297 19.7725 20.4297 21.0995V25.5355C20.4297 26.8627 21.4278 27.9383 22.6592 27.9383H26.7751ZM22.1446 25.5355V24.2417H23.8596V22.3933H22.1446V21.0995C22.1446 20.7937 22.3753 20.545 22.6592 20.545H26.7751C27.0589 20.545 27.2897 20.7936 27.2897 21.0995V22.3933H25.5746V24.2417H27.2897V25.5355C27.2897 25.8414 27.059 26.0901 26.7751 26.0901H22.6592C22.3753 26.09 22.1446 25.8414 22.1446 25.5355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7171 30.7108H21.2871V32.5592H24.7171V30.7108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7171 36.2559H21.2871V38.1042H24.7171V36.2559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1526 36.2559H36.7227V38.1042H40.1526V36.2559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8626 30.7108H26.4326V32.5592H29.8626V30.7108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0071 30.7108H31.5771V32.5592H35.0071V30.7108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1526 30.7108H36.7227V32.5592H40.1526V30.7108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7297 19.6208H53.0146V22.3933H54.7297V19.6208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 19.6208H49.585V22.3933H51.3V19.6208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8703 19.6208H46.1553V22.3933H47.8703V19.6208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4396 19.6208H42.7246V22.3933H44.4396V19.6208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4455 63.0567H54.7305V64.9051H56.4455V63.0567Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_6400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.45,
    height: 55.45,
    fill: "white",
    transform: "translate(17 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartfreeCredits);
export default __webpack_public_path__ + "static/media/StartfreeCredits.9a1eae732a09f3435c6d606d10ea323c.svg";
export { ForwardRef as ReactComponent };